import React from 'react';
import SectionLoadingError from "../common/SectionLoadingError";
import { Modal } from 'reactstrap';
import { logUI } from "../../api/andyliticsApi";
import * as Tools from "../../helpers/Tools";
import {
    INITIATE_GRANT_APPROVE_REQUEST_FALLBACK_TERMS
} from "../../constants/textConstants";
import Spinner from "../common/spinner";
import * as ProxyHelper from "./ProxyHelper";

class Terms extends React.Component {
    constructor(props) {
        super(props);
        this.state = { showModal: [], isAcceptTermsSelected: false };
        this.toggleModal = this.toggleModal.bind(this);
        this.acceptTermsSelected = this.acceptTermsSelected.bind(this);
        this.agreeAndFinish = this.agreeAndFinish.bind(this);
        this.updateState = this.updateState.bind(this);
    }

    componentDidMount() {
        logUI("MBHWeb.UI.Terms.ComponentDidMount", new Date(), Tools.getURLPath());
        this.updateState(); // if Terms is rendered from any standalone component 
    }

    componentDidUpdate(prevProps) {
        if (prevProps.links && this.props.links.length && prevProps.links.length !== this.props.links.length) {
            this.updateState(); // if Terms is rendered from any step of stepZilla (when user moves back and forth, pharmacy or healthrecord can be selected/deselected)
        }
    }

    updateState() {
        for (let link in this.props.links)            
            this.setState(prevState => ({
            showModal: prevState.showModal.concat(false)
        }));
    }

    toggleModal(index) {
        // if index matches with the current index of showModal array, lets toggle it else return same.
        this.setState(prevState => ({
            showModal:
                prevState.showModal.map((item, indexOfItem) => {
                    if (indexOfItem !== index)
                        return item;
                    return !item;
                })
        }));
    }

    isValidate() {
        return this.state.isAcceptTermsSelected;
    }

    acceptTermsSelected(e) {
        if (this.props.acceptTermsSelected)  // Needed for components under stepZilla.
            this.props.acceptTermsSelected(e);
        else { //Needed for standalone components.
            if (e.target && e.target.checked)
                this.setState({ isAcceptTermsSelected: true, validationError: "" });
            else
                this.setState({ isAcceptTermsSelected: false });
        }
    }

    agreeAndFinish() {        
        if (this.isValidate()) {
            logUI(this.props.activityCode ? this.props.activityCode : "MBHWeb.UI.Terms", new Date(), Tools.getURLPath(), { "AdultGrantingProxyAttestation": this.props.termsAndConditions ? ProxyHelper.sanitizeContent(this.props.termsAndConditions) : INITIATE_GRANT_APPROVE_REQUEST_FALLBACK_TERMS });
            if (this.props.callback)
                this.props.callback();
            else if (this.props.history) {
                this.props.history.push("/proxymanagement");
            }
        }
        else {
            const { isAcceptTermsSelected, validationError } = this.state;
            if (isAcceptTermsSelected && validationError !== "") {
                this.setState({ validationError: "" });
            }
            else if (validationError === "" || validationError === undefined) {
                this.setState({ isAcceptTermsSelected: false, validationError: "Please accept the terms." });
            }
        }
    }


    render() {
        const { errorMessage, containerClass, mainHeading, subHeading, links, style, validationError, showAgreeAndFinish = true, isMinor, isWaitingForTermsInfo } = this.props;        
        const error = validationError ? validationError : this.state.validationError;
        return (<div className={`${containerClass ? containerClass : "proxy-accept-terms-container"}`} style={style}>
                <div className="row">
                    {errorMessage ? <div className="col-12">
                        <SectionLoadingError message={errorMessage} />
                    </div> :
                        <>
                            <div className="col-12 text-center" >
                                <h1 className="step-heading step-heading-md no-prog-bar">{mainHeading}</h1>
                                <p>{subHeading}</p>
                                <h2 className="form-section-heading">By checking the box, you have read and agree to the
                                <>
                                        {links && links.map(link => (
                                            <span key={link.index}> <a href="#" onClick={(e) => { e.preventDefault(); this.toggleModal(link.index); }}> {link.headingText}</a>{link.index + 1 === links.length ? "" : " and"}
                                                <Modal isOpen={this.state.showModal[link.index]} toggle={() => this.toggleModal(link.index)} centered className="accept-terms-modal">
                                                    <div className="print-download-container">                                                       
                                                        <button className="btn btn-icon-only" title="Close" aria-label="Close" onClick={() => this.toggleModal(link.index)}><span className="icon-close modal-header-close-btn" /></button>
                                                    </div>
                                                    {link.modalComponent}
                                                </Modal>
                                            </span>))
                                        }.

                                    </>
                                </h2>
                                <div className="form-group grant-access-terms">
                                    <label className="checkbox-container">
                                        <input
                                            type="checkbox"
                                            name="agreeTermsAndConditions"
                                            onChange={this.acceptTermsSelected}
                                        />
                                        <span className="checkmark" />
                                        <span className="checkbox-label">I agree to the terms</span>
                                    </label>
                                </div>
                                {
                                    (error && error !== "") &&
                                    <div className="error-msg">
                                        {error}
                                    </div>
                                    }
                                {showAgreeAndFinish && <div className="footer-buttons">  
                                    <input type="submit" className="btn btn-primary" value="Agree and Submit" onClick={this.agreeAndFinish} />
                                </div>
                                }
                            </div>
                        </>
                    }
                    {isWaitingForTermsInfo &&
                        <>
                            <div className="row overlay-loading-container">
                                <div className="col-12 align-self-center">
                                    <Spinner />
                                </div>
                            </div>
                        </>
                    }
                </div>
            </div>
        );
    }
}

Terms.defaultProps = {
    mainHeading: "Great! Once you read and agree to the terms you'll be good to go.",
    subHeading: "Follow the links below and read the information carefully."
};

export default Terms;